import { IBannerResponseModel } from "../../core/models";
import ActionFooter from "../ActionFooter/ActionFooter";
import ArticlePdf from "../ArticlePdf/ArticlePdf";
import "./banner.scss";

export interface IBannerProps {
  content: IBannerResponseModel;
  onlyDocument: boolean;
}

const Banner = ({ content, onlyDocument }: IBannerProps) => {
  return (
    <section className="banner-detail">
      {onlyDocument ? (
        <ArticlePdf content={content}></ArticlePdf>
      ) : (
        <>
          <div className="banner-detail__top">
            <img
              className="banner-detail__head-image"
              src={content.listimage?.src}
              width={375}
              height={100}
              alt={content.listimage?.alt}
              style={{ height: "auto", width: "100%" }}
            />
            <h2 className="banner-detail__title">{content.title}</h2>
          </div>
          <div className="banner-detail__head">
            <div className="banner-detail__head-date">
              <span>{content.dateread?.split(" ")[0]}</span>
              <span>{content.dateread?.split(" ").slice(1)}</span>
            </div>
            <p className="banner-detail__head-description">{content.text}</p>
          </div>
        </>
      )}
    </section>
  );
};

export default Banner;
